module.exports = __webpack_public_path__ + "img/send-invites-mobile-ru.a2bc29db.jpg";